import type { SimpleChanges } from '@angular/core';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

import { RtAnalyticsModule, TrackDirective } from '@core/analytics-legacy';
import { TranslatePipe } from '@core/i18n-legacy';
import type { TOfferKind, OfferStatus } from '@core/offers-types';
import { OfferKind } from '@core/offers-types';
import { OfferStatusIndicatorComponent } from '@core/offers-ui';
import { BadgeComponent, RtTooltip } from '@core/user-interface-legacy';
import { getJobRouterLink } from '@recruitee/offers-util';

/*
 eslint-disable
 @typescript-eslint/consistent-type-assertions,
 @angular-eslint/no-inputs-metadata-property,
*/

@Component({
  imports: [
    OfferStatusIndicatorComponent,
    RtAnalyticsModule,
    RouterLink,
    TrackDirective,
    BadgeComponent,
    TranslatePipe,
    RtTooltip,
  ],
  template: `
    @if (offer.kind !== OfferKind.TalentPool) {
      <rt-offer-status-indicator [offerStatus]="offer" margin-right-small-x />
    }
    <a
      [routerLink]="offerLink"
      [rtcAnalyticsTrack]="'[Jobs] OpenJob'"
      [rtcAnalyticsTrackData]="{ status: offer.status }"
      (click)="$event.stopImmediatePropagation()"
    >
      <span>{{ offer.title }}</span>
    </a>
    @if (offer.wysiwygEditor === 'redactor') {
      <span class="badge-wrapper"
        ><rt-badge
          [text]="'app.offer.action_needed' | translate"
          [color]="'warning-tint'"
          [iconName]="'warning'"
          [rtTooltip]="'app.offer.action_needed_tooltip' | translate"
        ></rt-badge
      ></span>
    }
  `,
  styleUrls: ['./offer-title-cell.component.less'],
  host: {
    '[class]': '"title"',
  },
  inputs: OfferTitleCellComponent.NgInputs,
})
export class OfferTitleCellComponent {
  public static NgInputs = ['offer' as const];

  protected readonly OfferKind = OfferKind;

  public offer: {
    kind: TOfferKind;
    status: OfferStatus;
    title: string;
    slug: string;
    wysiwygEditor: 'prosemirror' | 'redactor';
  };

  protected offerLink: string[];

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.offer) {
      const isTalentPool = this.offer.kind === OfferKind.TalentPool;
      this.offerLink = isTalentPool
        ? ['/offers', this.offer.slug, 'filters']
        : getJobRouterLink(this.offer);
    }
  }
}
